import { Badge } from "@/components/ui/badge";

const statusMap = {
  compliant: { label: "Compliant", className: "bg-green-50 text-green-700 hover:bg-green-50" },
  non_compliant: { label: "Non-Compliant", className: "bg-red-50 text-red-700 hover:bg-red-50" },
  pending_review: { label: "Pending Review", className: "bg-violet-50 text-violet-700 hover:bg-violet-50" },
  expiring_soon: { label: "Expiring Soon", className: "bg-amber-50 text-amber-700 hover:bg-amber-50" },
  expired: { label: "Expired", className: "bg-red-100 text-red-800 hover:bg-red-100" },
  processing: { label: "Uploaded — Processing", className: "bg-blue-50 text-blue-700 hover:bg-blue-50" },
  invited: { label: "Invited", className: "bg-slate-100 text-slate-600 hover:bg-slate-100" },
  archived: { label: "Archived", className: "bg-slate-100 text-slate-600 hover:bg-slate-100" },
};

export function StatusBadge({ status }) {
  const current = statusMap[status] || statusMap.invited;
  return (
    <Badge className={`gap-1.5 rounded-full border-0 px-2.5 py-1 font-medium ${current.className}`} data-testid={`status-badge-${status}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {current.label}
    </Badge>
  );
}